<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineOfTheMonth.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineWineOfTheMonthForm :wineOfTheMonth="wineOfTheMonth" :APIbaseURL="APIbaseURL" />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineWineOfTheMonthForm from '@/components/AveineWineOfTheMonthForm.vue'
import WineOfTheMonth from '@/store/models/wine-of-the-month'
import { errorHandler } from 'aveine-toolbox'

export default {
  name: 'Update',
  components: { AveineWineOfTheMonthForm },
  data () {
    return {
      wineOfTheMonth: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    try {
      await WineOfTheMonth.api().get(
        `wines-of-the-month/${this.$route.params.id}?lang=${this.$i18n.locale}`,
        { baseURL: this.APIbaseURL, params: { include: 'wine.template.domain,tags' } }
      )
      // `withAllRecursive` : sans lui, `wine` et `tags` restent des identifiants
      // et le formulaire s'ouvrirait sans vin ni etiquettes.
      this.wineOfTheMonth = WineOfTheMonth.query()
        .whereId(this.$route.params.id)
        .withAllRecursive()
        .first()
      this.dataLoaded = true
    } catch (errors) {
      this.dataLoaded = true
      errorHandler(errors, this)
    }
  }
}
</script>
